import { api } from "./apiClient";
import { LogEntry } from "@/types/log";

export const logsService = {
  getAll: (params: {
    fechaInicio?: string;
    fechaFin?: string;
    filtroCriterio?: string;
    filtroValor?: string;
  } = {}) => {
    const query = new URLSearchParams();
    if (params.fechaInicio) query.append('fechaInicio', params.fechaInicio);
    if (params.fechaFin) query.append('fechaFin', params.fechaFin);
    if (params.filtroCriterio) query.append('filtroCriterio', params.filtroCriterio);
    if (params.filtroValor) query.append('filtroValor', params.filtroValor);
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return api.get<LogEntry[]>(`/logs/${suffix}`);
  },
};
